import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';

import useRelatedRefinementList from './custom/useRelatedRefinementList';

export type ModelVariantFilterProps = {
  attribute: string;
  label: string;
  parentAttribute: string;
  relatedAttributes: string | string[];
  filtersOpen?: boolean;
};

const ModelVariantFilter = ({
  attribute,
  label,
  relatedAttributes,
  parentAttribute,
  filtersOpen,
}: ModelVariantFilterProps) => {
  //check to see if parent attribute has selected facets
  const { items: parentItems } = useRelatedRefinementList({
    attribute: parentAttribute,
    relatedAttributes: [],
  });

  const parentFacetSelected = parentItems.some((item) => item.isRefined);

  const { items, refine } = useRelatedRefinementList({
    attribute,
    relatedAttributes,
  });

  const lowerCaseLabel = label.toLowerCase();
  const singularLabel = lowerCaseLabel.slice(0, -1);

  type Facet = (typeof items)[number];

  const sortedItems = items.reduce((result, item) => {
    const [make, model] = item.escapedValue.split(' > ');
    const makeOrModel = label === 'Models' ? make : `${make} ${model}`;

    if (!result[makeOrModel]) {
      result[makeOrModel] = [] as Array<Facet>;
    }

    result[makeOrModel].push(item);
    return result;
  }, {} as Record<string, Facet[]>);

  const noneSelected = !items.some((item) => item.isRefined);

  const selectedOptions = noneSelected
    ? ''
    : Object.entries(sortedItems).reduce((result, [makeOrModel, items]) => {
        const selectedCount = items.filter((item) => item.isRefined).length;
        if (selectedCount === 0) return result;

        const label = `${makeOrModel}: ${selectedCount} ${
          selectedCount === 1 ? singularLabel : lowerCaseLabel
        }`;

        return result ? `${result}, ${label}` : label;
      }, '');

  return (
    <InstantSearchAccordion
      disabled={!parentFacetSelected}
      filtersOpen={filtersOpen}
      label={label}
      selectedOptions={selectedOptions}
    >
      <>
        {Object.entries(sortedItems).map(([makeOrModel, items]) => (
          <section className="ch-mv--2" key={makeOrModel}>
            <p className="ch-fs--3 ch-fw--500 ch-mb--3">
              {makeOrModel} {lowerCaseLabel}
            </p>
            <ul>
              {items.map((item) => (
                <InstantSearchFilterOption.CheckBox
                  count={item.count}
                  id={item.name}
                  isSelected={item.isRefined}
                  key={item.escapedValue}
                  label={
                    item.escapedValue.split('>').pop()?.trim() ||
                    item.escapedValue
                  }
                  onChange={() => refine(item.escapedValue)}
                />
              ))}
            </ul>
          </section>
        ))}
      </>
    </InstantSearchAccordion>
  );
};

export default ModelVariantFilter;
